import { useRef } from 'react';
import TitleInput from './inputs/title';
import BodyInput from './inputs/body';
import DescriptionInput from './inputs/description';
import { Spinner } from '../../../components/ui';
import { useUserGeneratedContent } from '../../../models/user-generated-contents/context';
import PostMedia, {
  type PostMediaHandle,
  ACCEPTED_MEDIA_TYPES,
  MAX_MEDIA_FILES,
} from './media/post-media';
import Dropzone from './media/dropzone';
import './form.scss';

const UserGeneratedContentFormFields = () => {
  const postMediaRef = useRef<PostMediaHandle>(null);
  const { isLoading } = useUserGeneratedContent();

  if (isLoading) {
    return (
      <div className="post-form">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="post-form">
      <TitleInput />
      <DescriptionInput />
      <hr className="post-form__divider" />
      <Dropzone
        accept={ACCEPTED_MEDIA_TYPES}
        maxFiles={MAX_MEDIA_FILES}
        onDropAccepted={(files) =>
          postMediaRef.current?.handleDropAccepted(files)
        }
        onDropRejected={(rejections) =>
          postMediaRef.current?.handleDropRejected(rejections)
        }
      >
        <BodyInput />
        <PostMedia ref={postMediaRef} />
      </Dropzone>
    </div>
  );
};

export default UserGeneratedContentFormFields;
